export default __webpack_public_path__ + "static/media/RepeatMockUp.d007a41a.jpg";